import { jwtDecode } from 'jwt-decode';

export type UserRole =
  | 'admin'
  | 'staff'
  | 'manager'
  | 'support'
  | 'operation'
  | 'account'
  | 'packer'
  | 'rider'
  | 'customer'
  | 'vendor'
  | 'tagger'
  | 'guard'
  | 'audit'
  | 'agency'
  | 'driver';

export interface AccessClaims {
  id?: number;
  user_id?: number;
  name?: string;
  username?: string;
  phone_number?: string;
  role?: UserRole;
  is_superuser?: boolean;
  exp: number;
  iat?: number;
}

/** Internal roles that get the ads admin experience. */
export const ADS_ADMIN_ROLES: ReadonlySet<UserRole> = new Set([
  'admin',
  'staff',
  'manager',
  'support',
  'operation',
  'account',
]);

export function decodeAccess(token: string): AccessClaims | null {
  try {
    return jwtDecode<AccessClaims>(token);
  } catch {
    return null;
  }
}

export function isExpired(claims: AccessClaims | null, skewSeconds = 30): boolean {
  if (!claims) return true;
  return Date.now() / 1000 >= claims.exp - skewSeconds;
}

export function isAdvertiser(claims: AccessClaims | null): boolean {
  return !!claims && claims.role === 'vendor';
}

export function isAdsAdmin(claims: AccessClaims | null): boolean {
  if (!claims) return false;
  if (claims.is_superuser) return true;
  return !!claims.role && ADS_ADMIN_ROLES.has(claims.role);
}
